/*
  Avyanna "Layer it with" (sections/avyanna-layer-it-with.liquid) and "Picked for your cart" (sections/avyanna-cart-picks.liquid)
  Tabs, arrows and dots, Recently viewed (kept in this browser; only the first few pieces are fetched
  until the tab is opened), and the Choose options window.
  No outside libraries. Adds to the cart through the theme's own product form.
*/
(function(){
  var RV_KEY = 'avyanna-recent-v1', RV_MAX = 20;
  var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root){
    if(!root || root.dataset.alwInit) return;
    root.dataset.alwInit = '1';
    root.classList.add('alw-js');
    var handle = root.dataset.handle, max = parseInt(root.dataset.max, 10) || 10;
    var tabs = [].slice.call(root.querySelectorAll('[data-tab]'));
    var more = root.querySelector('[data-more-link]'), dots = root.querySelector('[data-dots]');
    var arrows = root.querySelector('[data-arrows]'), prev = root.querySelector('[data-prev]'), next = root.querySelector('[data-next]');
    var current = null;

    /* ---------- Recently viewed: remember this product (newest first) ---------- */
    var rv = [];
    try { rv = JSON.parse(localStorage.getItem(RV_KEY) || '[]'); if(!Array.isArray(rv)) rv = []; } catch(e){ rv = []; }
    rv = rv.filter(function(h){ return typeof h === 'string' && h; });
    var others = rv.filter(function(h){ return h !== handle; });
    /* only product pages add to the list (the cart page section has no product of its own) */
    if(handle){ try { localStorage.setItem(RV_KEY, JSON.stringify([handle].concat(others).slice(0, RV_MAX))); } catch(e){} }

    /* ---------- Photos: fade in once loaded; hover photo only fetched when a mouse rests on a card ---------- */
    function wirePhotos(scope){
      [].forEach.call(scope.querySelectorAll('.alw-media img.alw-pri'), function(im){
        function done(){ im.classList.add('is-ld'); }
        if(im.complete && im.naturalWidth){ done(); return; }
        im.addEventListener('load', done, { once:true });
        im.addEventListener('error', done, { once:true });
      });
      [].forEach.call(scope.querySelectorAll('.alw-media img.alw-sec'), function(im){
        im.addEventListener('load', function(){ im.classList.add('is-ld'); }, { once:true });
      });
    }
    if(window.matchMedia('(hover:hover) and (pointer:fine)').matches){
      root.addEventListener('pointerover', function(e){
        var card = e.target.closest && e.target.closest('.alw-card');
        var im = card && card.querySelector('img.alw-sec[data-srcset]');
        if(im){ im.srcset = im.dataset.srcset; im.removeAttribute('data-srcset'); }
      }, { passive:true });
    }

    /* ---------- Row: arrows (desktop, only when there are more cards than fit) and dots (phones) ---------- */
    function track(){ var p = current && root.querySelector('[data-panel="' + current + '"]'); return p && p.querySelector('[data-track]'); }
    function update(){
      var t = track(); if(!t) return;
      var maxS = t.scrollWidth - t.clientWidth;
      var over = maxS > 4;
      arrows.classList.toggle('is-on', over);
      prev.disabled = t.scrollLeft <= 4; next.disabled = t.scrollLeft >= maxS - 4;
      var n = t.children.length, pages = Math.max(1, Math.ceil(n / 2));
      if(!over || pages < 2){ dots.innerHTML = ''; return; }
      if(dots.children.length !== pages){ dots.innerHTML = new Array(pages + 1).join('<i></i>'); }
      var at = Math.round((t.scrollLeft / maxS) * (pages - 1));
      [].forEach.call(dots.children, function(d, i){ d.classList.toggle('is-on', i === at); });
    }
    var ticking = false;
    function onScroll(){ if(ticking) return; ticking = true; requestAnimationFrame(function(){ ticking = false; update(); }); }
    root.querySelectorAll('[data-track]').forEach(function(t){ t.addEventListener('scroll', onScroll, { passive:true }); });
    function page(dir){
      var t = track(); if(!t) return;
      var li = t.querySelector('.alw-li'); var step = li ? li.getBoundingClientRect().width + parseFloat(getComputedStyle(t).columnGap || 0) : t.clientWidth;
      var per = Math.max(1, Math.round(t.clientWidth / step));
      t.scrollBy({ left: dir * per * step, behavior: still ? 'auto' : 'smooth' });
    }
    prev.addEventListener('click', function(){ page(-1); });
    next.addEventListener('click', function(){ page(1); });
    window.addEventListener('resize', onScroll);

    /* ---------- Tabs: a tab's cards go on the page the first time it is opened ---------- */
    function fill(name){
      var p = root.querySelector('[data-panel="' + name + '"]'); if(!p) return;
      var t = p.querySelector('[data-track]'), tpl = p.querySelector('template[data-tpl]');
      if(tpl){ t.appendChild(tpl.content.cloneNode(true)); tpl.remove(); wirePhotos(t); }
      if(name === 'recent' && rvCards){ addRecent(t); moreRecent(); }
    }
    function select(name, focus){
      current = name;
      tabs.forEach(function(b){
        var on = b.dataset.tab === name;
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
        if(on && focus) b.focus();
      });
      root.querySelectorAll('[data-panel]').forEach(function(p){ p.hidden = p.dataset.panel !== name; });
      fill(name);
      var b = root.querySelector('[data-tab="' + name + '"]');
      more.hidden = !b.dataset.more;
      if(b.dataset.more){ more.href = b.dataset.more; more.textContent = b.dataset.moreLabel; }
      dots.innerHTML = '';
      var t = track(); if(t) t.scrollLeft = 0;
      update();
    }
    tabs.forEach(function(b){
      b.addEventListener('click', function(){ if(b.dataset.tab !== current) select(b.dataset.tab); });
      b.addEventListener('keydown', function(e){
        if(e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var vis = tabs.filter(function(x){ return !x.hidden; }), i = vis.indexOf(b);
        var n = vis[(i + (e.key === 'ArrowRight' ? 1 : -1) + vis.length) % vis.length];
        if(n){ e.preventDefault(); select(n.dataset.tab, true); }
      });
    });
    var first = tabs.filter(function(b){ return b.getAttribute('aria-selected') === 'true' && !b.hidden; })[0];
    if(first){ current = first.dataset.tab; wirePhotos(root); update(); }

    /* ---------- Recently viewed: cards fetched once the section is near the screen ----------
       Only enough pieces to fill the first view are fetched up front (a few at a time);
       the rest are fetched when the shopper opens the Recently viewed tab. */
    var rvCards = null, rvList = [], rvPos = 0, rvGone = [], rvFound = [], rvMore = null, RV_FIRST = 6;
    var rvSeen = root.dataset.seen || '|';
    var rvBase = root.dataset.root || '/'; if(rvBase.slice(-1) !== '/') rvBase += '/';
    function one(h){
      var url = rvBase + 'products/' + encodeURIComponent(h);
      return fetch(url + '?section_id=avyanna-layer-it-with', { credentials:'same-origin' })
        .then(function(r){ if(r.status === 404) return { gone:true }; if(!r.ok) throw 0; return r.text(); })
        .then(function(x){
          if(x && x.gone) return x;
          var li = new DOMParser().parseFromString(x, 'text/html').querySelector('[data-lw-cards] > li');
          if(li) return li;
          /* fallback: the section as placed on that product's page carries the product's own card */
          return fetch(url + '?section_id=' + encodeURIComponent(root.dataset.sid), { credentials:'same-origin' })
            .then(function(r){ return r.ok ? r.text() : ''; })
            .then(function(y){
              var d = new DOMParser().parseFromString(y, 'text/html'), tp = d.querySelector('template[data-lw-self]');
              return tp ? tp.content.querySelector('li') : null;
            });
        })
        .catch(function(){ return null; });
    }
    /* fetch the next n handles; keeps their order, skips gone / already shown pieces */
    function rvBatch(n){
      var part = rvList.slice(rvPos, rvPos + n); rvPos += part.length;
      return Promise.all(part.map(one)).then(function(res){
        res.forEach(function(li, i){
          if(li && li.gone){ rvGone.push(part[i]); return; }
          if(!li || rvFound.length >= max) return;
          if(rvSeen.indexOf('|' + li.dataset.pid + '|') > -1) return; /* already shown in another tab */
          rvFound.push(document.importNode(li, true));
        });
        if(rvGone.length){
          var g = rvGone; rvGone = [];
          try {
            var keep = JSON.parse(localStorage.getItem(RV_KEY) || '[]').filter(function(h){ return g.indexOf(h) < 0; });
            localStorage.setItem(RV_KEY, JSON.stringify(keep));
          } catch(e){}
        }
      });
    }
    function rvLeft(){ return rvPos < rvList.length && rvFound.length < max; }
    /* put any fetched cards that aren't on the row yet onto it */
    function addRecent(t){
      var from = t.children.length;
      if(from >= rvFound.length) return;
      rvFound.slice(from).forEach(function(li){ t.appendChild(li); });
      wirePhotos(t);
      if(current === 'recent'){ update(); }
    }
    /* the rest of the list, only once the tab is opened */
    function moreRecent(){
      if(rvMore || !rvLeft()) return;
      rvMore = rvBatch(rvList.length - rvPos).then(function(){
        var p = root.querySelector('[data-panel="recent"]'), t = p && p.querySelector('[data-track]');
        if(t){ addRecent(t); }
      });
    }
    function loadRecent(){
      if(!root.dataset.recent || !window.fetch || !window.DOMParser) return;
      rvList = others.slice(0, max + 4);
      if(rvList.length < 2) return;
      (function step(){
        rvBatch(rvPos === 0 ? RV_FIRST : RV_FIRST - rvFound.length).then(function(){
          if(rvFound.length < RV_FIRST && rvLeft()){ step(); return; }
          if(rvFound.length < 2) return;
          rvCards = rvFound;
          var tb = root.querySelector('[data-tab="recent"]'); tb.hidden = false;
          if(root.hidden){ root.hidden = false; select('recent'); }
        });
      })();
    }
    if(root.dataset.recent && others.length >= 2){
      if('IntersectionObserver' in window){
        var io = new IntersectionObserver(function(en){
          if(en.some(function(x){ return x.isIntersecting; })){ io.disconnect(); loadRecent(); }
        }, { rootMargin:'600px 0px' });
        io.observe(root.hidden ? (root.parentElement || root) : root);
      } else { loadRecent(); }
    }

    /* ---------- Choose options window (same as the collection page) ---------- */
    var qv = root.querySelector('[data-dlg="choose"]');
    if(!qv) return;
    var lastOpener = null;
    function openDlg(dlg){
      dlg.classList.remove('is-closing');
      if(typeof dlg.showModal === 'function'){ dlg.showModal(); } else { dlg.setAttribute('open', ''); }
      document.documentElement.style.overflow = 'hidden';
    }
    function closeDlg(dlg){
      if(!dlg.open || dlg.classList.contains('is-closing')) return;
      function done(){
        dlg.classList.remove('is-closing');
        if(typeof dlg.close === 'function'){ dlg.close(); } else { dlg.removeAttribute('open'); dlg.dispatchEvent(new Event('close')); }
      }
      if(still){ done(); return; }
      dlg.classList.add('is-closing');
      setTimeout(done, 300);
    }
    qv.addEventListener('close', function(){ document.documentElement.style.overflow = ''; if(lastOpener && lastOpener.isConnected){ lastOpener.focus(); } });
    qv.addEventListener('cancel', function(e){ e.preventDefault(); closeDlg(qv); });
    qv.addEventListener('click', function(e){ if(e.target === qv){ closeDlg(qv); } });
    qv.querySelectorAll('[data-close]').forEach(function(b){ b.addEventListener('click', function(){ closeDlg(qv); }); });

    var cache = {}, money = qv.dataset.money || '\x7B\x7Bamount\x7D\x7D';
    var qImg = qv.querySelector('[data-qv-img]'), qBrand = qv.querySelector('[data-qv-brand]'), qTitle = qv.querySelector('[data-qv-title]');
    var qPrice = qv.querySelector('[data-qv-price]'), qOpts = qv.querySelector('[data-qv-opts]'), qId = qv.querySelector('[data-qv-id]');
    var qAdd = qv.querySelector('[data-qv-add]'), qAddT = qv.querySelector('[data-qv-addt]'), qLink = qv.querySelector('[data-qv-link]');
    var qForm = qv.querySelector('product-form-component'), qErr = qv.querySelector('.alw-qv-err');
    var addT = root.dataset.atc || 'Add to cart', soldT = root.dataset.sold || 'Sold out', cur = null;
    function fmt(c){
      var n = (c || 0) / 100, a = n.toLocaleString('en-US', { minimumFractionDigits:2, maximumFractionDigits:2 });
      return money.replace(/\{\s*\{\s*(\w+)\s*\}\s*\}/, function(m, k){
        if(k === 'amount_no_decimals') return Math.round(n).toLocaleString('en-US');
        if(k === 'amount_with_comma_separator') return a.replace(/,/g, '#').replace('.', ',').replace(/#/g, '.');
        if(k === 'amount_no_decimals_with_comma_separator') return Math.round(n).toLocaleString('de-DE');
        return a;
      });
    }
    function sized(src, w){ if(!src) return ''; src = typeof src === 'string' ? src : (src.src || ''); if(src.indexOf('//') === 0) src = 'https:' + src; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
    function chosen(){ return [].map.call(qOpts.querySelectorAll('fieldset'), function(f){ var c = f.querySelector('input:checked'); return c ? c.value : null; }); }
    function match(sel){ return cur.variants.filter(function(v){ return sel.every(function(x, i){ return x === null || v.options[i] === x; }); }); }
    function refresh(){
      var sel = chosen(), v = match(sel)[0] || null;
      qOpts.querySelectorAll('fieldset').forEach(function(f, i){
        var b = f.querySelector('legend b'); if(b) b.textContent = sel[i] || '';
        f.querySelectorAll('input').forEach(function(inp){
          var test = sel.slice(); test[i] = inp.value;
          var ok = match(test).some(function(x){ return x.available; });
          inp.nextElementSibling.classList.toggle('is-off', !ok);
        });
      });
      qId.value = v ? v.id : '';
      var avail = !!(v && v.available);
      qAdd.disabled = !avail;
      qAddT.textContent = avail ? addT : soldT;
      var p = v ? v.price : cur.price, cp = v ? v.compare_at_price : cur.compare_at_price;
      qPrice.innerHTML = '';
      if(cp && cp > p){ var s = document.createElement('s'); s.textContent = fmt(cp); var n = document.createElement('span'); n.className = 'is-sale'; n.textContent = fmt(p); qPrice.append(s, n); }
      else { qPrice.textContent = fmt(p); }
      var im = (v && v.featured_image) || cur.featured_image;
      if(im){ qImg.src = sized(im, 640); }
      qLink.href = cur.url + (v ? '?variant=' + v.id : '');
      if(qErr) qErr.classList.add('hidden');
    }
    function build(p, url){
      cur = p; cur.url = url.split('?')[0];
      qForm.dataset.productId = p.id;
      qBrand.textContent = p.vendor || ''; qTitle.textContent = p.title; qTitle.href = cur.url;
      qImg.alt = p.title;
      var firstV = p.variants.filter(function(v){ return v.available; })[0] || p.variants[0];
      qOpts.innerHTML = '';
      (p.options || []).forEach(function(o, i){
        var name = typeof o === 'string' ? o : o.name;
        var vals = (typeof o === 'object' && o.values) ? o.values : p.variants.map(function(v){ return v.options[i]; }).filter(function(x, k, a){ return a.indexOf(x) === k; });
        if(p.variants.length === 1 && vals.length === 1) return;
        var fs = document.createElement('fieldset'), lg = document.createElement('legend'), wrap = document.createElement('div');
        lg.textContent = name; lg.appendChild(document.createElement('b'));
        wrap.className = 'alw-qv-vals';
        vals.forEach(function(val, k){
          var id = 'alw-qv-' + root.dataset.sid + '-' + i + '-' + k, inp = document.createElement('input'), lb = document.createElement('label');
          inp.type = 'radio'; inp.name = 'alw-qv-o' + i; inp.id = id; inp.value = val; inp.checked = firstV && firstV.options[i] === val;
          lb.htmlFor = id; lb.textContent = val;
          inp.addEventListener('change', refresh);
          wrap.append(inp, lb);
        });
        fs.append(lg, wrap); qOpts.appendChild(fs);
      });
      refresh();
    }
    root.addEventListener('click', function(e){
      var a = e.target.closest && e.target.closest('[data-qv]');
      if(!a || !root.contains(a)) return;
      if(!window.fetch || typeof qv.showModal !== 'function') return;
      e.preventDefault();
      var url = a.dataset.qv;
      function show(p){ wireEvents(); build(p, url); lastOpener = a; openDlg(qv); var f = qv.querySelector('.alw-qv-vals input:checked') || qAdd; setTimeout(function(){ f.focus({ preventScroll:true }); }, 60); }
      if(cache[url]){ show(cache[url]); return; }
      a.classList.add('is-loading');
      fetch(url.split('?')[0] + '.js', { headers:{ Accept:'application/json' } })
        .then(function(r){ if(!r.ok) throw 0; return r.json(); })
        .then(function(p){ cache[url] = p; show(p); })
        .catch(function(){ window.location.href = a.href; })
        .finally(function(){ a.classList.remove('is-loading'); });
    });
    /* close once the theme confirms the item is in the cart */
    var closeOnAdd = function(ev){
      if(!qv.open || !ev || !ev.promise) return;
      ev.promise.then(function(res){ var d = res && res.detail; if(d && !d.didError && d.sourceId === qForm.id){ setTimeout(function(){ closeDlg(qv); }, 350); } }).catch(function(){});
    };
    var evWired = false;
    function wireEvents(){
      if(evWired) return; evWired = true;
      import('@shopify/events').then(function(m){ document.addEventListener(m.StandardEvents.cartLinesUpdate, closeOnAdd); }).catch(function(){
        new MutationObserver(function(){ if(qAdd.dataset.added === 'true'){ setTimeout(function(){ closeDlg(qv); }, 900); } }).observe(qAdd, { attributes:true, attributeFilter:['data-added'] });
      });
    }
  }

  function boot(scope){ [].forEach.call((scope || document).querySelectorAll('.alw[data-sid]'), init); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', function(){ boot(); }); } else { boot(); }
  /* theme editor: a section was added or changed */
  document.addEventListener('shopify:section:load', function(e){ if(e.target && e.target.querySelectorAll) boot(e.target); });
})();
